import type { FC } from 'react';

import {
  Dialog,
  CommonDialogLayout,
  CouponInvalidDialogHead,
} from '@wwe-portal/ui/components/dialog';

interface CouponInvalidDialogProps {
  onClose?: () => void;
  open?: boolean;
  errorMessage?: string;
}
export const CouponInvalidDialog: FC<CouponInvalidDialogProps> = ({
  onClose,
  open = true,
  errorMessage,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        closable
        contentClass="w-[326px] h-[396px] px-[60px] rounded-5"
        dataId="CouponInvalidDialog"
        descriptionElement={
          <div className="my-4">Please apply another coupon</div>
        }
        imageElement={<CouponInvalidDialogHead />}
        layoutClass="px-0 2xl:px-0"
        onClose={onClose}
        titleElement={<div className="mt-6">{errorMessage}</div>}
      />
    </Dialog>
  );
};
